import React, { useContext, useRef, useEffect, useState } from "react";
import "./style.scss"; // Import or define your styles
// import { ListingInterface } from "context/ListingData";
import { UserContext } from "store";

const HighlightElement = ({ targetId, children, theme = {} }) => {
	const {
		state: { highlight },
		dispatch,
	} = useContext(UserContext);
	const highlightRef = useRef(null);
	const [position, setPosition] = useState({ top: 0, left: 0 });
	const [showTipPosition, setShowTipPosition] = useState({ top: 0, left: 0 });

	const handleClose = (event) => {
		if (highlightRef.current && !highlightRef.current.contains(event.target)) {
			dispatch({
				type: "SHOW_HIGHLIGHT",
				payload: false,
			});
		}
	};

	const scrollIntoView = () => {
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			var scrollPosition = window.scrollY;
			var elementPosition = targetElement.getBoundingClientRect().top;
			var targetScrollPosition = scrollPosition + elementPosition - 100;

			window.scrollTo({
				top: targetScrollPosition,
				behavior: "smooth",
			});

			// Calculate the position of the highlight element
			const rect = targetElement.getBoundingClientRect();
			setPosition({
				top: rect.top,
				left: rect.left,
			});

			// Calculate the position for the show-tip
			setShowTipPosition({
				top: rect.top + rect.height + 10, // Adjust as needed
				left: rect.left,
			});
		}
	};

	useEffect(() => {
		if (highlight) scrollIntoView();
	}, [highlight]);

	return (
		<div>
			{highlight && (
				<div>
					<div
						onClick={handleClose}
						style={{
							position: "fixed",
							overflow: "hidden",
							top: 0,
							left: 0,
							width: "calc(100% + 10px)",
							height: "calc(100% + 10px)",
							zIndex: 99999999,
							isolation: "isolate",
							backgroundColor: "rgba(0, 0, 0, 0.5)",
						}}
					></div>

					<div
						ref={highlightRef}
						style={{
							position: "sticky",
							top: position.top,
							left: position.left,
							background: theme?.background2 || "white",
							zIndex: 99999999,
							isolation: "isolate",
							padding: 20,
							borderRadius: 10,
						}}
					>
						<span
							style={{
								position: "absolute",
								background: theme?.background2,
								color: theme?.primaryTextColor,
								padding: 20,
								borderRadius: 10,
								top: 0,
								left: highlightRef?.current?.offsetWidth + 10,
								whiteSpace: "pre",
							}}
							className="show-tip"
						>
							Till we answer, you can ask your question here...
						</span>
						{children}
					</div>
				</div>
			)}
			{!highlight && children}
		</div>
	);
};

export default HighlightElement;
